const workflowTask = {
  id: null,
  workflowInstanceId: null,
  sourceTemplateTaskId: null,
  title: null,
  description: null,
  assignedToUserId: null,
  dueDate: null,
  statusId: null,
  blockerTaskId: null,
  sortOrder: 0,
  completedAt: null,
  completedBy: null,
  createdAt: null,
  updatedAt: null,
  createdBy: null,
  updatedBy: null,
  statusName: null,
  assignedToUserName: null,
  blockerTaskTitle: null,
  templateName: null,
  candidateName: null,
  clientName: null
}

export default () => Object.assign({}, workflowTask)
